import React from "react";
import ReactECharts from "echarts-for-react";

const YearLineChart = ({ type = "price" , years , values}) => {
    console.log("in chart year",years);
        console.log("in chart values",values);
//const hasData = values?.length && years?.length;

const hasData = Array.isArray(values) && values.length > 0 &&
                Array.isArray(years) && years.length > 0;
if (!hasData) {
  return (
    <div className="h-10 flex items-center justify-center text-gray-400 text-sm">
       Data is not ready yet , please check again later.
    </div>
  );
}
  
 console.log("hasData",hasData);
  const yLabelMap = {
    price: "Price (₹)",
    amount: "Amount (₹ Cr)",
    percent: "Percent (%)"
  };
  
  const option = {
     graphic: !hasData
    ? {
        type: "text",
        left: "center",
        top: "middle",
        style: {
          text: "No Data Available Yet",
          fill: "#9CA3AF",
          fontSize: 14,
          fontWeight: 500,
        },
      }
    : undefined,
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "line"
      },
      formatter: (params) => {
        const p = params[0];
        let suffix = "";

        if (type === "price") suffix = "₹";
        if (type === "amount") suffix = " Cr";
        if (type === "percent") suffix = "%";

        return `
          <b>Year:</b> ${p.axisValue}<br/>
          <b>${yLabelMap[type]}:</b> ${p.value}${suffix}
        `;
      }
    },
    grid: {
      left: "4%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },

    xAxis: hasData ? {
      type: "category",
      data: years,
      boundaryGap: false,
      show: false,
    } : { show: false },

    yAxis: hasData ? {
      type: "value",
      name: yLabelMap[type],
      show: false,
    }:{ show: false},

    series: hasData? [
      {
        type: "line",
        smooth: true,
        data: values,
        symbol: "circle",
        symbolSize: 10,
        lineStyle: { width: 2 },
        label: {
          show: true,
          position: "top",
          formatter: "{c}",
        },
      }
    ] : []
  };

  return (
    <div className="h-fit">
    <ReactECharts option={option}   style={{ height: 200, width: "100%" }} />
  </div>
  );
};

export default YearLineChart;
